import React, { useState } from 'react';

const PostcodeLookup = () => {
  const [postcode, setPostcode] = useState('');
  const [addresses, setAddresses] = useState([]);
  const [error, setError] = useState(null);

  const handleLookup = async () => {
    const formattedPostcode = postcode.replace(/\s/g, '');
    try {
      const res = await fetch(`https://api.getaddress.io/find/${formattedPostcode}?api-key=YOUR_API_KEY`);
      const data = await res.json();

      if (data.addresses && data.addresses.length > 0) {
        setAddresses(data.addresses);
        setError(null);
      } else {
        setAddresses([]);
        setError("कोई address नहीं मिला, कृपया सही postcode डालें।");
      }
    } catch (err) {
      setError("कुछ गलत हो गया, कृपया दोबारा प्रयास करें।");
      setAddresses([]);
    }
  };

  return (
    <div className="p-4 max-w-md mx-auto bg-white shadow-md rounded-xl">
      <h2 className="text-xl font-bold mb-4">Postcode Lookup</h2>
      <input
        type="text"
        value={postcode}
        onChange={(e) => setPostcode(e.target.value)}
        placeholder="Enter UK Postcode"
        className="border p-2 w-full mb-2 rounded"
      />
      <button
        onClick={handleLookup}
        className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
      >
        Find Addresses
      </button>

      {error && <p className="text-red-500 mt-2">{error}</p>}

      {addresses.length > 0 && (
        <div className="mt-4">
          <h3 className="font-bold">Addresses Found:</h3>
          <ul className="list-disc pl-6">
            {addresses.map((address, index) => (
              <li key={index}>
                <p><strong>Address {index + 1}:</strong> {address}</p>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default PostcodeLookup